import React from 'react';
import { DISPLAY_MODE } from '../../utils/paymentPlanDisplay';

const STATUS_CONFIG = {
    ACTIVE: {
        className: 'bg-success-subtle text-success',
        icon: 'bi-calendar-check',
    },
    DELINQUENT: {
        className: 'bg-warning-subtle text-dark',
        icon: 'bi-exclamation-triangle',
    },
    BROKEN: {
        className: 'bg-danger-subtle text-danger',
        icon: 'bi-exclamation-triangle',
    },
    COMPLETED: {
        className: 'bg-info-subtle text-info',
        icon: 'bi-check-circle',
    },
    CANCELED: {
        className: 'bg-secondary-subtle text-secondary',
        icon: 'bi-x-circle',
    },
    DRAFT: {
        className: 'bg-warning-subtle text-dark',
        icon: 'bi-clock',
    },
};

const DISPLAY_MODE_CONFIG = {
    [DISPLAY_MODE.PAYMENT_PLAN_ACTIVE]: STATUS_CONFIG.ACTIVE,
    [DISPLAY_MODE.PAYMENT_PLAN_DELINQUENT]: STATUS_CONFIG.DELINQUENT,
    [DISPLAY_MODE.PAYMENT_PLAN_BROKEN]: STATUS_CONFIG.BROKEN,
    [DISPLAY_MODE.PAYMENT_PLAN_COMPLETED]: STATUS_CONFIG.COMPLETED,
    [DISPLAY_MODE.PAYMENT_PLAN_CANCELED]: STATUS_CONFIG.CANCELED,
};

const DISPLAY_MODE_LABELS = {
    [DISPLAY_MODE.PAYMENT_PLAN_ACTIVE]: 'Plan de pagos vigente',
    [DISPLAY_MODE.PAYMENT_PLAN_DELINQUENT]: 'Plan de pagos en mora',
    [DISPLAY_MODE.PAYMENT_PLAN_BROKEN]: 'Plan de pagos caído',
    [DISPLAY_MODE.PAYMENT_PLAN_COMPLETED]: 'Plan de pagos completado',
    [DISPLAY_MODE.PAYMENT_PLAN_CANCELED]: 'Plan de pagos cancelado',
};

/**
 * Badge for payment plan status on loan cards and detail headers.
 * Prefers BFF status_label when provided.
 */
function PaymentPlanStatusBadge({ status, displayMode, statusLabel, className = '' }) {
    const config =
        (status && STATUS_CONFIG[status]) ||
        (displayMode && DISPLAY_MODE_CONFIG[displayMode]) ||
        null;

    if (!config && !statusLabel) {
        return null;
    }

    const label =
        statusLabel ||
        DISPLAY_MODE_LABELS[displayMode] ||
        (status && STATUS_CONFIG[status]?.label) ||
        status;

    const resolvedConfig = config || STATUS_CONFIG.ACTIVE;

    return (
        <span
            className={`badge ${resolvedConfig.className} d-inline-flex align-items-center gap-1 ${className}`}
        >
            <i className={`bi ${resolvedConfig.icon}`}></i>
            {label}
        </span>
    );
}

export default PaymentPlanStatusBadge;
